import HiveOutlined from "@mui/icons-material/HiveOutlined";
import type { FC } from "react";
import { useId } from "react";

interface ExosIconProps {
  fontSize?: { xs: number; sm: number };
}

export const ExosIcon: FC<ExosIconProps> = ({ fontSize }) => {
  const gradientId = useId();

  return (
    <>
      <svg width="0" height="0" aria-hidden="true" focusable="false">
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#00B6EF" />
            <stop offset="100%" stopColor="#C24599" />
          </linearGradient>
        </defs>
      </svg>
      <HiveOutlined sx={{ fill: `url(#${gradientId})`, fontSize }} />
    </>
  );
};
